import { FilterType, Filter, FilterKey, EventInfoStatus } from 'types';
import { IGetFilterGroupsProps } from '../../types';

import { IOption } from 'shared-components';

import { getInterviewInfoStatusString } from '@/utilities/formatting';
import { UserRole } from '@/store/auth/types';

const getOptions = (userRole?: UserRole): IOption[] => {
  const isAgentUser = (userRole && [UserRole.Agent, UserRole.AgencyAdmin].includes(userRole)) ?? false;
  return [
    {
      label: getInterviewInfoStatusString(EventInfoStatus.INVITED),
      value: EventInfoStatus.INVITED,
    },
    {
      label: getInterviewInfoStatusString(EventInfoStatus.BOOKED),
      value: EventInfoStatus.BOOKED,
    },
    ...(isAgentUser
      ? []
      : [
          {
            label: getInterviewInfoStatusString(EventInfoStatus.FAILED),
            value: EventInfoStatus.FAILED,
          },
          {
            label: getInterviewInfoStatusString(EventInfoStatus.PASSED),
            value: EventInfoStatus.PASSED,
          },
          {
            label: getInterviewInfoStatusString(EventInfoStatus.RESIT),
            value: EventInfoStatus.RESIT,
          },
        ]),
    {
      label: getInterviewInfoStatusString(EventInfoStatus.NONE),
      value: EventInfoStatus.NONE,
    },
  ];
};

const key = FilterKey.INTERVIEW;
export const getInterviewFilter = ({ activeFilters, userRole }: IGetFilterGroupsProps): Filter => {
  const filters = activeFilters[key] ?? [];
  const options = getOptions(userRole).map(({ label, value }) => {
    return {
      label,
      value,
      checked: filters.some(filter => filter === value),
    };
  });
  return {
    name: 'Interview bookings',
    key,
    type: FilterType.SELECT_MANY,
    showSearch: false,
    options: {
      SELECT_MANY: options,
    },
  };
};
